var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 12.7647C2.75 9.48048 5.42578 6.80469 8.70999 6.80469H10.131C10.5452 6.80469 10.881 7.14047 10.881 7.55469C10.881 7.9689 10.5452 8.30469 10.131 8.30469H8.70999C6.25421 8.30469 4.25 10.3089 4.25 12.7647C4.25 15.2121 6.25486 17.2237 8.70999 17.2237H10.131C10.5452 17.2237 10.881 17.5595 10.881 17.9737C10.881 18.3879 10.5452 18.7237 10.131 18.7237H8.70999C5.42512 18.7237 2.75 16.0393 2.75 12.7647Z",
    fill: "#791469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2501 12.7647C22.2501 9.48048 19.5743 6.80469 16.2901 6.80469H14.8691C14.4549 6.80469 14.1191 7.14047 14.1191 7.55469C14.1191 7.9689 14.4549 8.30469 14.8691 8.30469H16.2901C18.7459 8.30469 20.7501 10.3089 20.7501 12.7647C20.7501 15.2121 18.7452 17.2237 16.2901 17.2237H14.8691C14.4549 17.2237 14.1191 17.5595 14.1191 17.9737C14.1191 18.3879 14.4549 18.7237 14.8691 18.7237H16.2901C19.575 18.7237 22.2501 16.0393 22.2501 12.7647Z",
    fill: "#791469"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4707 12.7656C8.4707 12.3514 8.80649 12.0156 9.2207 12.0156H15.7801C16.1943 12.0156 16.5301 12.3514 16.5301 12.7656C16.5301 13.1798 16.1943 13.5156 15.7801 13.5156H9.2207C8.80649 13.5156 8.4707 13.1798 8.4707 12.7656Z",
    fill: "#791469"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e21acfd16068deef4424f8f5e1c25dba.svg";
export { ForwardRef as ReactComponent };